export const MAIN_PAGE: string = "MAIN_PAGE";
export const SAFE_MESSAGE: string = "safe to edit";
export const CURRENTLY_EDITED_BY_YOU_MESSAGE: string = "currently edited by you";
export const LIVE_EDIT_TIMETOUT: number = 60;
export const LIVE_EDIT_REFRESH: number = 45;
export const FONT_FAMILY = `"Inter", monospace, -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto`;

export const COLORS = {
	PURPLE: {
		PRIMARY: "#4d2393",
		SECONDARY: "#dcd5e7"
	},
	GOLD: {
		PRIMARY: "#ffbd12",
		SECONDARY: "#f8e6b9"
	},
	GRAY: {
		90: "#212121",
		80: "#474747",
		70: "#747373",
		30: "#c1c1c1",
		20: "#dedede",
		10: "#f2f2f2"
	},
	SUCCESS: {
		PRIMARY: "#04732a",
		SECONDARY: "#d0eeda"
	},
	FAILURE: {
		PRIMARY: "#af2323",
		SECONDARY: "f3dada"
	}
};

export const LOGO = {
	IMAGE_LINK: "https://static.igem.wiki/teams/4441/wiki/logo.png",
	HEIGHT: 80,
	MIN_HEIGHT: 60
}

export const NAVBAR_MIN_WIDTH = 768;

export const NAVBAR_MIN_HEIGHT = 84;

export const GALLERY_COL_COUNT = 3;


/**
 * From igem-cli json output
 */
export const IMAGE_URLS = {
	"accordion.svg":"https://2021.igem.org/wiki/images/4/4e/T--Washington--accordion.svg",
	"banner.svg":"https://2021.igem.org/wiki/images/a/a5/T--Washington--banner.svg",
	"gallery.svg":"https://2021.igem.org/wiki/images/a/a8/T--Washington--gallery.svg",
	"grid.svg":"https://2021.igem.org/wiki/images/0/00/T--Washington--grid.svg",
	"header.svg":"https://2021.igem.org/wiki/images/3/36/T--Washington--header.svg",
	"image-carousel.svg":"https://2021.igem.org/wiki/images/d/d9/T--Washington--image-carousel.svg",
	"image.svg":"https://2021.igem.org/wiki/images/b/b8/T--Washington--image.svg",
	"images-in-row.svg":"https://2021.igem.org/wiki/images/3/39/T--Washington--images-in-row.svg",
	"pdf-reader.svg":"https://2021.igem.org/wiki/images/a/a6/T--Washington--pdf-reader.svg",
	"rich-text-editor.svg":"https://2021.igem.org/wiki/images/1/18/T--Washington--rich-text-editor.svg",
	"separator-vertical.svg":"https://2021.igem.org/wiki/images/0/07/T--Washington--separator-vertical.svg",
	"stub.svg":"https://2021.igem.org/wiki/images/0/0c/T--Washington--stub.svg",
	"tab.svg":"https://2021.igem.org/wiki/images/9/9e/T--Washington--tab.svg",
	"video.svg":"https://2021.igem.org/wiki/images/6/65/T--Washington--video.svg"
}
